import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import React from 'react';
import { ButtonAlign } from '../Button/consts';
import ButtonLink from '../ButtonLink/ButtonLink';
import { ClickableAction } from '../Clickable/consts';
import RichText from '../RichText/RichText';
import styles from './RegioContactSection.module.scss';
import { RegioContactSectionProps } from './types';

const RegioContactSection = ({
  title,
  subTitle = 'Rufen Sie uns gerne an, Mo.-Fr. von 08-20 Uhr & Sa. von 09-14 Uhr<br/>oder schreiben uns eine E-Mail.',
  phone = '0800.36372489',
  mail = 'kundenservice@enercity.de',
  children,
}: RegioContactSectionProps) => {
  const isMobile = useIsMobile(768);

  return (
    <div className={styles.base}>
      <h3 className={styles.title}>{title}</h3>

      <RichText className={styles.subTitle}>{subTitle}</RichText>

      <div className={styles.buttonContainer}>
        <ButtonLink
          className={styles.button}
          actionType={ClickableAction.Phone}
          phone={phone}
          hasOutlinedIcon
          customIconSize="iconSize64"
          align={isMobile ? ButtonAlign.Center : ButtonAlign.Right}
        >
          {phone}
        </ButtonLink>

        <ButtonLink
          className={styles.button}
          actionType={ClickableAction.MailTo}
          email={mail}
          hasOutlinedIcon
          customIconSize="iconSize64"
          align={isMobile ? ButtonAlign.Center : ButtonAlign.Left}
        >
          {mail}
        </ButtonLink>
      </div>
      {children}
    </div>
  );
};

const RegioContactSectionRichText = ({ children }: React.PropsWithChildren) => {
  return <RichText className={styles.text}>{children}</RichText>;
};

export default Object.assign(RegioContactSection, {
  RichText: RegioContactSectionRichText,
});
